// extracted by mini-css-extract-plugin
module.exports = {"form":"bs","isSubmitting":"bt","row":"bu","column":"bv","warning":"bw"};